export const tr = {
    number: '№ {id}'
};
